import { TFunction } from 'i18next';
import Select from '@lib/components/Select/Select';
import LangOption from '@lib/components/Select/components/LangOption';
import { FieldItem } from '@lib/interfaces/form';
import { getOptionValidation } from '@lib/utils/validationUtils';
import UserFieldNames from '@lib/enums/fieldNames/userFieldNames';
import { langOptions } from '@lib/utils/lang';
import styles from '../components/ProfileForm.module.scss';

type LangFormFieldsArgs = {
  t: TFunction<'translation', undefined>;
  loading: boolean;
};

export default function getLangFormFields({
  t,
  loading,
}: LangFormFieldsArgs): FieldItem[] {
  return [
    {
      name: UserFieldNames.Lang,
      label: t('choose-language'),
      element: Select,
      validation: getOptionValidation({ required: true, t }),
      formItemClassName: styles.column,
      componentProps: {
        disabled: loading,
        options: langOptions,
        isClearable: false,
        menuPlacement: 'top',
        components: {
          Option: LangOption,
        },
      },
    },
  ];
}
